// src/visaCategories.ts

export interface SubCategory {
  id: string;
  label: string;
  officialString: string;
}

export interface MainCategory {
  id: string;
  label: string;
  icon: string;
  officialPrefix: string;
  subCategories: SubCategory[];
}

export const MAIN_VISA_CATEGORIES: MainCategory[] = [
  {
    id: 'e-Tourist 30 Days',
    label: 'e-Tourist Visa (for 30 Days)',
    icon: '🏝️',
    officialPrefix: 'e-Tourist Visa (for 30 Days)',
    subCategories: [
      { id: 'sightseeing_30', label: 'Recreation / Sight Seeing', officialString: 'e-Tourist Visa (for 30 Days) - RECREATION/SIGHT SEEING' },
      { id: 'friends_30', label: 'Meet Friends or Relatives', officialString: 'e-Tourist Visa (for 30 Days) - MEET FRIENDS/RELATIVES' },
      { id: 'yoga_30', label: 'Attending Short Term Yoga Programme', officialString: 'e-Tourist Visa (for 30 Days) - ATTENDING SHORT TERM YOGA PROGRAMME' },
      { id: 'courses_30', label: 'Short Term Courses (less than 6 months)', officialString: 'e-Tourist Visa (for 30 Days) - SHORT TERM COURSES (LESS THAN 6 MONTHS)' },
      { id: 'voluntary_30', label: 'Voluntary Work (Short Duration)', officialString: 'e-Tourist Visa (for 30 Days) - VOLUNTARY WORK (SHORT DURATION)' },
    ],
  },
  {
    id: 'e-Tourist 1 Year',
    label: 'e-Tourist Visa (for 1 Year)',
    icon: '📅',
    officialPrefix: 'e-Tourist Visa (for 1 Year)',
    subCategories: [
      { id: 'sightseeing_1y', label: 'Recreation / Sight Seeing', officialString: 'e-Tourist Visa (for 1 Year) - RECREATION/SIGHT SEEING' },
      { id: 'friends_1y', label: 'Meet Friends or Relatives', officialString: 'e-Tourist Visa (for 1 Year) - MEET FRIENDS/RELATIVES' },
      { id: 'yoga_1y', label: 'Attending Short Term Yoga Programme', officialString: 'e-Tourist Visa (for 1 Year) - ATTENDING SHORT TERM YOGA PROGRAMME' },
      { id: 'courses_1y', label: 'Short Term Courses (less than 6 months)', officialString: 'e-Tourist Visa (for 1 Year) - SHORT TERM COURSES (LESS THAN 6 MONTHS)' },
      { id: 'voluntary_1y', label: 'Voluntary Work (Short Duration)', officialString: 'e-Tourist Visa (for 1 Year) - VOLUNTARY WORK (SHORT DURATION)' },
    ],
  },
  {
    id: 'e-Tourist 5 Years',
    label: 'e-Tourist Visa (for 5 Years)',
    icon: '🌟',
    officialPrefix: 'e-Tourist Visa (for 5 Years)',
    subCategories: [
      { id: 'sightseeing_5y', label: 'Recreation / Sight Seeing', officialString: 'e-Tourist Visa (for 5 Years) - RECREATION/SIGHT SEEING' },
      { id: 'friends_5y', label: 'Meet Friends or Relatives', officialString: 'e-Tourist Visa (for 5 Years) - MEET FRIENDS/RELATIVES' },
      { id: 'yoga_5y', label: 'Attending Short Term Yoga Programme', officialString: 'e-Tourist Visa (for 5 Years) - ATTENDING SHORT TERM YOGA PROGRAMME' },
      { id: 'courses_5y', label: 'Short Term Courses (less than 6 months)', officialString: 'e-Tourist Visa (for 5 Years) - SHORT TERM COURSES (LESS THAN 6 MONTHS)' },
      { id: 'voluntary_5y', label: 'Voluntary Work (Short Duration)', officialString: 'e-Tourist Visa (for 5 Years) - VOLUNTARY WORK (SHORT DURATION)' },
    ],
  },
  {
    id: 'e-Business',
    label: 'e-Business Visa',
    icon: '💼',
    officialPrefix: 'e-Business Visa',
    subCategories: [
      { id: 'trade', label: 'Sale / Purchase / Trade', officialString: 'e-Business Visa - SALE/PURCHASE/TRADE' },
      { id: 'meetings', label: 'Attend Technical or Business Meetings', officialString: 'e-Business Visa - ATTEND TECHNICAL/BUSINESS MEETINGS' },
      { id: 'venture', label: 'Setting up Industrial / Business Venture', officialString: 'e-Business Visa - SETTING UP INDUSTRIAL/BUSINESS VENTURE' },
      { id: 'manpower', label: 'Recruit Manpower', officialString: 'e-Business Visa - RECRUIT MANPOWER' },
      { id: 'exhibitions', label: 'Participate in Exhibitions / Trade Fairs', officialString: 'e-Business Visa - PARTICIPATE IN EXHIBITIONS/COLLEGE TRADE FAIRS' },
      { id: 'expert', label: 'Expert / Specialist for Ongoing Project', officialString: 'e-Business Visa - EXPERT/SPECIALIST FOR ONGOING PROJECT' },
      { id: 'tours', label: 'Conduct Tours / Tour Operator', officialString: 'e-Business Visa - CONDUCT TOURS' },
      { id: 'sports', label: 'Participate in Sports Activities', officialString: 'e-Business Visa - PARTICIPATE IN SPORTS ACTIVITIES' },
      { id: 'vessel', label: 'Join Vessel at Indian Port', officialString: 'e-Business Visa - JOIN VESSEL AT INDIAN PORT' },
    ],
  },
  {
    id: 'e-Medical',
    label: 'e-Medical & Attendant Visa',
    icon: '🏥',
    officialPrefix: 'e-Medical Visa',
    subCategories: [
      { id: 'med_self', label: 'Medical Treatment of Self', officialString: 'e-Medical Visa - MEDICAL TREATMENT OF SELF' },
      { id: 'med_attendant', label: 'Attendant to e-Medical Visa Holder', officialString: 'e-Medical Attendant Visa - ATTENDANT TO E-MEDICAL VISA HOLDER' },
      { id: 'ayush_self', label: 'Ayush Treatment (Ayurveda/Yoga)', officialString: 'e-Ayush Visa - AYUSH TREATMENT OF SELF' },
      { id: 'ayush_attendant', label: 'Attendant to e-Ayush Visa Holder', officialString: 'e-Ayush Attendant Visa - ATTENDANT TO E-AYUSH VISA HOLDER' },
    ],
  },
  {
    id: 'e-Conference',
    label: 'e-Conference Visa',
    icon: '🎤',
    officialPrefix: 'e-Conference Visa',
    subCategories: [
      { id: 'conference', label: 'Attend Conference / Seminar / Workshop', officialString: 'e-Conference Visa - TO ATTEND CONFERENCE/SEMINAR/WORKSHOP' },
    ],
  },
  {
    id: 'Other',
    label: 'Other e-Visas (Transit, Student, Emergency)',
    icon: '✈️',
    officialPrefix: 'Other',
    subCategories: [
      { id: 'transit', label: 'e-Transit Visa (En route to another country)', officialString: 'e-Transit Visa - TRANSIT THROUGH INDIA' },
      { id: 'student', label: 'e-Student Visa', officialString: 'e-Student Visa - HIGHER EDUCATION IN INDIA' },
      { id: 'emergency', label: 'e-Emergency X-Misc Visa', officialString: 'e-Emergency X-Misc Visa - EMERGENCY SITUATION' },
    ],
  },
];
